// @ts-nocheck
import {
    chain,
    LoadProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import { addToChainBefore, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const PopulateApiParameter = createChainHandler("PopulateApiParameter", chain, props => {
    if (props.getProductCollectionParameter === undefined) {
        return;
    }
    props.getProductCollectionParameter = {
        ...props.getProductCollectionParameter,
        additionalExpands: ["attributes"],
    };
});

addToChainBefore(chain, LoadProducts, PopulateApiParameter);
